import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";
import {StoryMessage} from "../DB/storyMessages/@StoryMessage.js";

const MTClass = StoryMessage;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		entry: DeriveJSONSchema(MTClass, {}),
	}),
	responseSchema: ()=>SimpleSchema({id: {$ref: "UUID"}}),
})
export class AddStoryMessage extends Command<{entry: MT}, {id: string}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		$updates: DeriveJSONSchema(MTClass, {excludeKeys: ["id", "creator", "createdAt"], makeOptional_all: true}),
	}),
})
export class UpdateStoryMessage extends Command<{id: string, updates: Partial<MT>}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		id: {$ref: "UUID"},
	}),
})
export class DeleteStoryMessage extends Command<{id: string}> {}

/*const childMessages = GetStoryMessages(this.userInfo!.id, oldData.story, id);
AssertV(childMessages.length == 0, "Cannot delete story message while it still has child messages.");

/*if (oldData.parent == null) {
	const story = GetStory.NN(oldData.story);
	this.sub_updateStory = new UpdateStory({id: story.id, updates: {
		startMessageIds: story.startMessageIds.Exclude(id),
	}}).MarkAsSubcommand(this);
	this.sub_updateStory.Validate();
}*#/*/